import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { hrSubNav } from "@/lib/navigationItems";

export const Route = createFileRoute("/portal/hr")({
  component: HrLayout,
});

/**
 * HR Lite is internal-only for now (Larasoft/Iridium JV): visible + reachable
 * only by platform admins. The backend also enforces the `hr` RBAC resource.
 */
function HrLayout() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const isPlatformAdmin = user?.is_admin === true;

  useEffect(() => {
    if (!isLoading && !isPlatformAdmin) {
      navigate({ to: "/portal" });
    }
  }, [isLoading, isPlatformAdmin, navigate]);

  if (isLoading || !isPlatformAdmin) {
    return null;
  }

  return (
    <div className="space-y-4">
      <ProductSubNav items={hrSubNav} />
      <Outlet />
    </div>
  );
}
